var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as AppConfig from './AppConfig';
import { gql } from '@apollo/client/core';
import * as Collection from "../api/collection";
import * as GqlCollection from "../api/collection/GqlCollection";
const APP_CONFIG_FIELDS = gql `
  fragment AppConfigFields on AppConfig {
    id
    name
    appContext
    applicationId
    urlBase
    origin
    enforceOrigin
  }
`;
const APP_CONFIG_QUERY = gql `
  query AppConfig($id: Int!) {
    app {
      applicationConfiguration(id: $id) {
        ...AppConfigFields
      }
    }
  }
  ${APP_CONFIG_FIELDS}
`;
const APP_CONFIGS_QUERY = gql `
  query AppConfigs($id: Int, $page: Int, $limit: Int) {
    app {
      applicationConfigurations(id: $id, page: $page, limit: $limit) {
        collection {
          ...AppConfigFields 
        }
        metadata {
          ...CollectionMetadataFields
        }
      }
    }
  }
  ${Collection.Api.COLLECTION_METADATA_FIELDS}
  ${APP_CONFIG_FIELDS}
`;
const SAVE_APP_CONFIG_MUTATION = gql `
  mutation SaveAppConfig($appConfig: AppConfigAttributes!) {
    app {
      saveAppConfig(input: {appConfig: $appConfig}) {
        appConfig {
          ...AppConfigFields
        }
        errors
      }
    }
  }
  ${APP_CONFIG_FIELDS}
`;
export const fetchAppConfigPage = (client_1, ...args_1) => __awaiter(void 0, [client_1, ...args_1], void 0, function* (client, params = {}) {
    const { data } = yield client.query({
        query: APP_CONFIGS_QUERY,
        variables: {
            page: params === null || params === void 0 ? void 0 : params.page,
            limit: params === null || params === void 0 ? void 0 : params.limit,
        },
    });
    return GqlCollection.fromGql(data.app.applicationConfigurations, AppConfig.fromGqlCollection);
});
export const fetchAppConfig = (client, id) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield client.query({
        query: APP_CONFIG_QUERY,
        variables: {
            id,
        },
    });
    return AppConfig.fromGql(data.app.applicationConfiguration);
});
export const saveAppConfig = (client, payload) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield client.mutate({
        mutation: SAVE_APP_CONFIG_MUTATION,
        variables: {
            appConfig: payload,
        },
    });
    client.cache.evict({ id: `AppConfig:${payload.id}` });
    client.cache.gc();
    return {
        appConfig: data.app.saveAppConfig.appConfig && AppConfig.fromGql(data.app.saveAppConfig.appConfig),
        errors: data.app.saveAppConfig.errors,
    };
});
//# sourceMappingURL=Api.js.map